import MagicHeader from '../../widgets/MagicHeader';
import FaqAccordion from '../../widgets/FaqAccordion';
import '../magic.css';

// Own implementation (rather than re-exporting classic's) so the header/logo stay
// consistent with the rest of the magic template instead of the classic default header.
const FAQ = () => {
  return (
    <div className="magic-theme-light">
      <MagicHeader variant="light" showBack onBack={() => window.history.back()} />
      <main className="page-content strict-width x-space-top">
        <h4 className="title mb-3">Frequently Asked Questions</h4>
        <FaqAccordion />
      </main>
    </div>
  );
};

export default FAQ;
